import React from 'react';
import ConfigService from "../../../Services/api/Config";

class IconBlue extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    const {
      children,
      color
    } = this.props;

    return (
      <div className='Help'
           style={
            { backgroundColor: color ? ConfigService.getColor(color) : ConfigService.getColor('secondaryColor') }
           }
      >
        { children }
      </div>
    );
  }
}

export default IconBlue;